import React from 'react'
import ReactDOM from 'react-dom'
import { ThemeProvider } from 'styled-components'
import { DndProvider } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'

import App from './App'
import { Amplify } from 'aws-amplify'
import config from 'config/aws'
import theme from 'config/theme'

import 'style/index.scss'
import './i18n/init'

import * as Sentry from '@sentry/react'

import posthog from 'posthog-js'
import { PostHogProvider } from '@posthog/react'
import { Authenticator } from '@aws-amplify/ui-react'

Sentry.init({
	dsn: import.meta.env.VITE_SENTRY_DSN,
	environment: import.meta.env.VITE_STAGE,
	// local dev server should not report to Sentry
	enabled: !import.meta.env.DEV
})

if (import.meta.env.PROD) {
  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST,
    capture_exceptions: true,
    defaults: '2025-11-30',
    cross_subdomain_cookie: false
  })
}

// window.LOG_LEVEL = 'DEBUG'
// Amplify.Logger.LOG_LEVEL = 'DEBUG'

Amplify.configure(config)

const Index = () => {
	return(
		<PostHogProvider client={posthog}>
			<ThemeProvider theme={theme}>
				<DndProvider backend={HTML5Backend} options={{ enableMouseEvents: true }}>
					<Authenticator.Provider>
						<App/>
					</Authenticator.Provider>
				</DndProvider>
			</ThemeProvider>
		</PostHogProvider>
	)
}

ReactDOM.render(
	<Index />,
	document.getElementById('root')
)
